export enum AzureB2CErrorCodes {
	ForgotPassword = 'AADB2C90118',
	CancelledUserCreation = 'AADB2C90091',
}
